import React from 'react';

import {Trans} from '../../libs/shared/helpers/src/internationalization/react';
import {ApplicationEntryPointActionFeaturesEnum} from '../models/api/applicationEntryPointActionModel';

/*
 * Constants.
 */

export const renderedApplicationEntryPointActionFeaturesMap: {
  [key in ApplicationEntryPointActionFeaturesEnum]: React.ReactNode;
} = {
  [ApplicationEntryPointActionFeaturesEnum.DEVICE_CAMERA]: (
    <Trans id="application-entry-point-action-feature-camera">Camera</Trans>
  ),
  [ApplicationEntryPointActionFeaturesEnum.DEVICE_CLIPBOARD]: (
    <Trans id="application-entry-point-action-feature-clipboard">Clipboard</Trans>
  ),
  [ApplicationEntryPointActionFeaturesEnum.DEVICE_FULLSCREEN]: (
    <Trans id="application-entry-point-action-feature-fullscreen">Fullscreen</Trans>
  ),
  [ApplicationEntryPointActionFeaturesEnum.DEVICE_MICROPHONE]: (
    <Trans id="application-entry-point-action-feature-microphone">Microphone</Trans>
  ),
  [ApplicationEntryPointActionFeaturesEnum.DISPLAY_CAPTURE]: (
    <Trans id="application-entry-point-action-feature-display-capture">Display Capture</Trans>
  ),
};
